import type { SVGProps } from 'react'
const SvgSyMicAlt = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g strokeLinejoin="round">
			<path
				fillOpacity={0.24}
				d="M12 3c3.324 0 6 2.676 6 6v4c0 3.324-2.676 6-6 6s-6-2.676-6-6V9c0-3.324 2.676-6 6-6"
			/>
			<path d="M12 2.4A6.6 6.6 0 0 0 5.4 9v4c0 3.646 2.954 6.6 6.6 6.6s6.6-2.954 6.6-6.6V9c0-3.646-2.954-6.6-6.6-6.6m0 1.2c3.002 0 5.4 2.398 5.4 5.4v4c0 3.002-2.398 5.4-5.4 5.4A5.376 5.376 0 0 1 6.6 13V9c0-3.002 2.398-5.4 5.4-5.4" />
			<path d="M12 18.4a.6.6 0 0 0-.6.6v3a.6.6 0 0 0 .6.6.6.6 0 0 0 .6-.6v-3a.6.6 0 0 0-.6-.6m-5-6a.6.6 0 0 0-.6.6.6.6 0 0 0 .6.6h3a.6.6 0 0 0 .6-.6.6.6 0 0 0-.6-.6zm9 0a.6.6 0 0 0-.6.6.6.6 0 0 0 .6.6h2a.6.6 0 0 0 .6-.6.6.6 0 0 0-.6-.6zm-9-4a.6.6 0 0 0-.6.6.6.6 0 0 0 .6.6h3a.6.6 0 0 0 .6-.6.6.6 0 0 0-.6-.6zm9 0a.6.6 0 0 0-.6.6.6.6 0 0 0 .6.6h2a.6.6 0 0 0 .6-.6.6.6 0 0 0-.6-.6z" />
		</g>
	</svg>
)
export default SvgSyMicAlt
